import React from 'react';
import '../../BarManagementSection/CertificateSection/Certificate.css';
import { Link } from 'react-router-dom';

function SpecialCertificate() {
  return (
    <div className='certificate-outer'>
      <div className="certificate-inner">
        <h2 className="header-text">Get Your Certificate In <br/>Foreign Language</h2>
        <button className="cta-text"><Link to='/contact'>Admission Open</Link></button>
      </div>
    </div>
  )
}

export default SpecialCertificate
